import {PropsWithChildren} from 'react';

import Label from '@/components/form/label';

type Props = PropsWithChildren<{
  labelFor: string;
  ['data-testid']: string;
  label: string;
}>;

export const CombinedFields = ({label, labelFor, ['data-testid']: dataTestId, children}: Props) => {
  return (
    <div className="flex flex-col">
      <Label htmlFor={labelFor} data-testid={dataTestId} multiline={false}>
        {label}
      </Label>

      <div className="flex gap-4">{children}</div>
    </div>
  );
};
